module.exports = __webpack_public_path__ + "img/promo-bg--375.5215704.jpg";